import { createSelector } from 'reselect';

export const hiddenTagListSelector = createSelector(
  state => state.entities,
  state => state.entities.hiddenTags,
  (entities, hiddenTags) => {
    return hiddenTags.allIds.map(id => hiddenTags.byId[id]).map(hiddenTag => {
      const tagInfo = hiddenTag.object_content;
      return {
        ...hiddenTag,
        object_content: entities[tagInfo.schema].byId[tagInfo.id],
      };
    });
  }
);



// WEBPACK FOOTER //
// ./src/selectors/hiddenTagSelectors.js